/**
 * ¿Es un enlace de ESTE admin? Lo que pinta una alarma como «Ir al origen» sale
 * de metadatos que puede haber escrito cualquiera, así que sólo se enlaza una
 * ruta interna: nunca otro host (`//x`, `/\x`), un esquema (`javascript:`) ni
 * caracteres de control.
 *
 * El texto del patrón es EL MISMO que `INTERNAL_LINK_PATTERN` en
 * `platform-admin/backend/app/services/alarm_engine.py`, y un test compara los
 * dos: si cambias uno, cambia el otro.
 */
export const INTERNAL_LINK_PATTERN = String.raw`^/(?![/\\])[A-Za-z0-9/_.~%?=&-]*$`;

const INTERNAL_LINK_RE = new RegExp(INTERNAL_LINK_PATTERN);

export function isInternalLink(s: string | null | undefined): s is string {
  return typeof s === 'string' && INTERNAL_LINK_RE.test(s);
}

/**
 * ¿Es un enlace a Sentry? `https`, host `sentry.io` o un subdominio suyo, sin
 * usuario ni puerto. Gemelo de `is_sentry_url` del motor de alarmas.
 */
export function isSentryUrl(s: string | null | undefined): s is string {
  if (typeof s !== 'string' || /\s/.test(s) || [...s].some((ch) => ch.charCodeAt(0) < 32)) return false;
  let url: URL;
  try {
    url = new URL(s);
  } catch {
    return false;
  }
  const host = url.hostname.toLowerCase();
  return (
    url.protocol === 'https:'
    && (host === 'sentry.io' || host.endsWith('.sentry.io'))
    && url.username === ''
    && url.password === ''
    && url.port === ''
    // `URL` quita el `:443` por defecto: se mira en el texto que llegó.
    && !/^https:\/\/[^/]*:/i.test(s)
  );
}
